"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialStateOfBookingServices = exports.bookingServicesReducer = void 0;
var _reduxActions = require("redux-actions");
var _ramda = require("ramda");
var _helpers = require("./helpers");
var _actions = require("./actions");
var _handleActions;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialStateOfBookingServices = exports.initialStateOfBookingServices = {
  activeServices: {},
  isShow: false,
  shouldRecalculatePrice: false,
  lastRecalculatedActiveServices: {},
  recalculatedPrice: null
};
var bookingServicesReducer = exports.bookingServicesReducer = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, _actions.setIsShow, function (state, _ref) {
  var isShow = _ref.payload;
  return (0, _ramda.assoc)('isShow', isShow, state);
}), _actions.applyService, function (state, _ref2) {
  var _ref2$payload = _ref2.payload,
    serviceID = _ref2$payload.serviceID,
    touristId = _ref2$payload.touristId;
  return (0, _ramda.over)((0, _ramda.lensPath)(['activeServices', serviceID]), function (activeService) {
    return (0, _ramda.mergeAll)([activeService, (0, _helpers.mapTourist2Service)(touristId)]);
  }, state);
}), _actions.detachService, function (state, _ref3) {
  var _ref3$payload = _ref3.payload,
    serviceID = _ref3$payload.serviceID,
    touristId = _ref3$payload.touristId;
  var prevTouristCount = (0, _ramda.keys)(state.activeServices[serviceID]).length;
  if (prevTouristCount === 1) {
    return (0, _ramda.dissocPath)(['activeServices', serviceID], state);
  }
  return (0, _ramda.dissocPath)(['activeServices', serviceID, touristId], state);
}), _actions.setActiveServicesById, function (state, _ref4) {
  var _ref4$payload = _ref4.payload,
    serviceID = _ref4$payload.serviceID,
    touristIds = _ref4$payload.touristIds;
  var next = (0, _helpers.mapTourists2Service)(touristIds);
  return (0, _ramda.assocPath)(['activeServices', serviceID], next, state);
}), _actions.detachActiveServicesById, function (state, _ref5) {
  var serviceID = _ref5.payload.serviceID;
  return (0, _ramda.dissocPath)(['activeServices', serviceID], state);
}), _actions.setActiveServices, function (state, _ref6) {
  var services = _ref6.payload;
  return (0, _ramda.assoc)('activeServices', services, state);
}), _actions.setRecalculatedPrice, function (state, _ref7) {
  var price = _ref7.payload;
  return (0, _ramda.assoc)('recalculatedPrice', price, state);
}), _actions.setLastRecalculatedActiveServices, function (state, _ref8) {
  var activeServicesMap = _ref8.payload;
  return (0, _ramda.assoc)('lastRecalculatedActiveServices', activeServicesMap, state);
}), _actions.forceApplyRecalculate, function (state) {
  return (0, _ramda.assoc)('lastRecalculatedActiveServices', {
    ALWAYS_RECALCULATE_SERVICES: true
  }, state);
}), _actions.setShouldRecalculatePrice, function (state, _ref9) {
  var should = _ref9.payload;
  return (0, _ramda.assoc)('shouldRecalculatePrice', should, state);
}), _defineProperty(_handleActions, _actions.updateRecalculatedPrice, function (state, _ref0) {
  var price = _ref0.payload;
  return (0, _ramda.assocPath)(['recalculatedPrice', 'price'], price, state);
})), initialStateOfBookingServices);